// CONCATENATED MODULE: ./node_modules/@pixelunion/shopify-components/sections/product/default/product.js

class Product extends Core.SectionComponent {
  constructor(el, context) {
    super(el, context);

    const { selectedVariant } = this.data;

    this.state = {
      selectedVariant,
    };

    this.events.register(el, 'product:add-to-cart:success', event => this._onAddToCartSuccess(event));
    this.events.register(el, 'product:variant-change', event => this._onVariantChange(event));
    const firstVariant = JSON.parse(document.querySelector('[data-current-variant]').textContent).variant;
    this._refreshProduct(firstVariant);
    const productGridEl = el.querySelector('[data-product-grid]');
    const productGridColumnDetailsEl = el.querySelector('[data-product-grid-column-details]');
    const resizeObserver = new ResizeObserver(entries => {
      for (let i = 0; i < entries.length; i++) {
        const entry = entries[i];
        const viewportHeight = window.visualViewport.height;
        const { height, top, bottom } = productGridEl.getBoundingClientRect();
        const pxInViewport = Math.max(
          0,
          top > 0
            ? Math.min(height, viewportHeight - top)
            : Math.min(bottom, viewportHeight),
        );

        if (entry.contentRect.height <= pxInViewport) {
          productGridEl.dataset.stickyPosition = 'top';
        } else {
          productGridEl.dataset.stickyPosition = 'bottom';
        }
      }
    });

    resizeObserver.observe(productGridColumnDetailsEl);
  }

  _getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i <ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  _onAddToCartSuccess() {
    const { selectedVariant } = this.state;

    this._refreshProduct(selectedVariant);
  }

  _onVariantChange(event) {
    const { variant, state } = event.detail;
    if (!variant) return;
     $(".smartwishlist.wishlist-trigger.wishlist-button").each((i,obj) => {
        var key = Object.keys(obj).pop();
        if(obj[key] && typeof obj[key] === 'object') {
          obj[key].variant = variant.id;
          $(obj).attr("data-variant", variant.id)
        }
      })

    setTimeout( () => {
          var wishlistid;
          if(this._getCookie("wishlist_id")){
            wishlistid = this._getCookie("wishlist_id")
            console.log('get in  if')
          } else {
            wishlistid = SWGetExpressWishlistId()
          }
          var isLogin = this._getCookie('wishlist_customer_id') != 0 ? true : false
          var wishlistParams = ''
          if(!isLogin){
            wishlistParams = `wishlistid=${wishlistid}`
          } else {
            wishlistParams = `customerid=${this._getCookie('wishlist_customer_id')}`
          }
          $.ajax({
            url: "/a/wishlist?type=api&"+wishlistParams+"&version=1",dataType: "json",cache:false,
            success: function(data) {
              let find = data.items.find(item => item.variant_id == variant.id)
              if(find){
                  $(".smartwishlist.wishlist-trigger.wishlist-button").each((i,obj) => {
                      var key = Object.keys(obj).pop();
                      var tooltip = obj[key].tooltipsterNs[0]
                      obj[key].variant = variant.id;
                      obj[key][tooltip].Content = obj[key][tooltip].Content.replaceAll("Add to","Remove from")

                      $(obj).attr("data-variant",variant.id)
                      $(obj).removeClass("unbookmarked")
                      $(obj).children("span.fa").removeClass("fa-heart-o")
                      $(obj).addClass("bookmarked")
                      $(obj).children("span.fa").addClass("fa-heart")
                  })
              }else{
                  $(".smartwishlist.wishlist-trigger.wishlist-button").each((i,obj) => {
                      var key = Object.keys(obj).pop();
                      var tooltip = obj[key].tooltipsterNs[0]
                      obj[key].variant = variant.id;
                      obj[key][tooltip].Content = obj[key][tooltip].Content.replaceAll("Remove from","Add to")

                      $(obj).attr("data-variant",variant.id)
                      $(obj).removeClass("bookmarked")
                      $(obj).children("span.fa").removeClass("fa-heart")
                      $(obj).children("span.fa").addClass("fa-heart-o")
                      $(obj).addClass("unbookmarked")
                  })
              }
            }
          });
        }, 0)

    if (state !== 'unselected') {
      this._refreshProduct(variant);

      this.setState({ selectedVariant: variant });
    }
  }

  _refreshProduct(variant) {
    $('[data-type="inventory_status"]').html("&nbsp;");
    $('[data-type="inventory_status"]').addClass("loading");
    $('.product-block__price-price').html("&nbsp;");
    $('.product-block__price-price').addClass("loading");
    // Update the price component using fetch
    fetch(`${this.data.url}/async?variant=${variant.id}&section_id=${this.sectionId}`)
      .then(response => response.text())
      .then(responseText => {
        let config = JSON.parse(localStorage.getItem('config'));
        let preOrder =false;
        const message = new Message("en-US");
        let messageValue = "";
        const leadTimeData = JSON.parse($('#lead-time').text());
        const variantLeadTime = leadTimeData.find(function (item) {
          return item.id === variant.id;
        })
        
        if(!config?.error && config){
            preOrder = config.product.variants[variant.id]?.config?.status === "ACTIVE" || config.product.variants[variant.id]?.config?.status === "NO_STOCK";

            if(config.settings.message.value != "" && preOrder){
              messageValue = message.populateDynamicValues(config.product.variants[variant.id],config.settings.message.value, /*isCartLabel=*/false)
            }
        }

        
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const skuBlockEl = html.querySelector('[data-type="sku"]');
        const priceBlockEl = html.querySelector('[data-type="price"]');
        const inventoryStatusBlockEl = html.querySelector('[data-type="inventory_status"]');
        const buyButtonsEl = html.querySelector('[data-type="buy_buttons"]');
        const sharingEl = html.querySelector('[data-type="share"]');
        const preorderInput = html.getElementById('variant-preorder');

        if (skuBlockEl) {
          this.el.querySelector('[data-type="sku"]').innerHTML = skuBlockEl.innerHTML;
        }

        if (priceBlockEl) {
          this.el.querySelector('[data-type="price"]').innerHTML = priceBlockEl.innerHTML;
        }

        if (inventoryStatusBlockEl) {
          this.el.querySelector('[data-type="inventory_status"]').innerHTML = inventoryStatusBlockEl.innerHTML;
           if(preOrder){
            $("p.block-inventory-status").text(messageValue);
          }
        }

        if (variantLeadTime) {
          const dateArr = variantLeadTime['lead_time'].indexOf('/') !== -1 ? variantLeadTime['lead_time'].split('/') : variantLeadTime['lead_time'].split('-');
          const dateValue = variantLeadTime['lead_time'].indexOf('/') !== -1 ?  new Date(dateArr[2], (+dateArr[0] - 1), dateArr[1]) :  new Date(dateArr[0], (+dateArr[1] - 1), dateArr[2]);
          const monthValue = dateValue.toLocaleString('default', { month: 'long' });

          if(variantLeadTime['lead_time'].indexOf('/') !== -1) {
            $("p.block-inventory-status").text('Pre-Order Ships ' + (monthValue + ' ' + dateArr[1] + ', ' + dateArr[2]));
          } else {
            $("p.block-inventory-status").text('Pre-Order Ships ' + (monthValue + ' ' + dateArr[2] + ', ' + dateArr[0]));
          }
          preorderInput.setAttribute('name', 'properties[Pre-Order]');
          preorderInput.value = variantLeadTime['lead_time'];
        } else {
          preorderInput.setAttribute('name', '');
          preorderInput.value = '';
        }
        if (buyButtonsEl) {
          this.el.querySelector('[data-type="buy_buttons"]').innerHTML = buyButtonsEl.innerHTML;
           if(preOrder){
            $('button.add-cart-trigger').text(config.settings.button.name)
            $('button.add-cart-trigger').val(config.settings.button.name)
            $("input#order-type").attr({
              name:"properties[Order Type]",
              value:messageValue
            })
          }
        }
        if (document.querySelector('.input-radio__input--Size') && document.querySelector('.input-radio__input--Size:checked')) {
          $('[data-type="inventory_status"]').css('opacity', '1');
        }
        if (sharingEl) {
          this.el.querySelector('[data-type="share"]').innerHTML = sharingEl.innerHTML;
        }
        $('[data-type="inventory_status"]').removeClass("loading");
        $('.product-block__price-price').removeClass("loading");
        var waitForJQuery = setInterval(function () {
          if (typeof jQuery != 'undefined') {
            if(typeof Afterpay != 'undefined'){
              Afterpay.init(jQuery)
              clearInterval(waitForJQuery);
            } else {
              return false
              clearInterval(waitForJQuery);
            }
            clearInterval(waitForJQuery);
          }
        }, 10);

        $('.block-inventory-status').removeClass( 'loading' );
        $( '.add-cart-trigger' ).css( 'color', variant.available ? 'white' : '' );
      });
  }
}

Core.Components.register(Product, 'product');